// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "5c361303b6c624c3499860f5fe91dc9ae26d6a71/static/css/" + chunkId + "." + "8ea9c403" + ".chunk.css";
};